/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PrivacyAliases {
  CARD_PRIVACY_WARNING = 'card-privacy-warning',
  CARD_TERM = 'card-term',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  CONTEXTUAL_BAR_TERMO = 'contextual-bar-termo',
  FETCH_0 = 'fetch-0',
  FETCH_PRIVACY_WARNING = 'fetch-privacy-warning',
  FETCH_STATUS = 'fetch-status',
  FETCH_STATUS_TERMO = 'fetch-status-termo',
  FETCH_TERM = 'fetch-term',
  FIELD_AVISO = 'field-aviso',
  FIELD_AVISO_VIGENCIA = 'field-aviso-vigencia',
  FIELD_PRIVACY_WARNING_TEXT = 'field-privacy-warning-text',
  FIELD_TERM_TEXT = 'field-term-text',
  FIELD_TERMO = 'field-termo',
  FIELD_TERMO_VIGENCIA = 'field-termo-vigencia',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  HPMS_DYNAMIC_CONTENT_FIELD = 'hpms-dynamic-content-field',
  HPMS_DYNAMIC_CONTENT_FIELD_TERM = 'hpms-dynamic-content-field-term',
  HPMS_TEXT_HTML_2 = 'hpms-text-html-2',
  HPMS_TEXT_HTML_PRIVACY_WARNING = 'hpms-text-html-privacy-warning',
  HPMS_TEXT_HTML_TERM = 'hpms-text-html-term',
  LAYOUT_0 = 'layout-0',
  MODAL_DESCRIPTION = 'modal-description',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_MODAL_DESCRIPTION = 'panel-modal-description',
  PANEL_PRIVACY_WARNING = 'panel-privacy-warning',
  PANEL_PRIVACY_WARNING_TEXT = 'panel-privacy-warning-text',
  PANEL_TERM = 'panel-term',
  PANEL_TERM_TEXT = 'panel-term-text',
  TEXT_AVISO = 'text-aviso',
  TEXT_AVISO_VIGENCIA = 'text-aviso-vigencia',
  TEXT_TERMO = 'text-termo',
  TEXT_TERMO_VIGENCIA = 'text-termo-vigencia',
}
export { PrivacyAliases };
